<template>
  <div class="row">
    <div class="col-12">
      <div class="text-center">
        <h2 class="mt-0">
          <i class="mdi mdi-check-all"></i>
        </h2>
        <h3 class="mt-0"> {{$t('common.upload_resume.steps.step6.body_title')}}</h3>

        <p class="w-75 mb-2 mx-auto">
         {{$t('common.upload_resume.steps.step6.body_text')}}
        </p>

        <div class="mb-3">
          <div class="custom-control custom-checkbox">
            <input
              id="customCheck2"
              type="checkbox"
              class="custom-control-input"
              ref="aggreement"
            />
            <label class="custom-control-label" for="customCheck2"
              >{{$t('common.upload_resume.steps.step6.agree_terms')}}</label
            >
          </div>
        </div>
      </div>
    </div>
    <!-- end col -->
  </div>
</template>


<script>
import { mapActions } from 'vuex'

export default {
  data(){
    return {
      model:{},
      loading:false
    }
  },
  methods: {
    async validate() {
      var isValid = false,
        agreement = this.$refs['aggreement']

      if(this.loading){
        alert('Finalizing, please wait.')
      }

      if(agreement.checked){
        this.loading = true
        await this.submitCandidate({...this.data, job_id:this.data.job_id}).then(res => {
          var data = res.data
          if(data.success){
            this.model.application = data.application
            this.model.candidate_id = data.candidate_id
            isValid = true
            this.loading = false
            if(data.toastMessage){
              this.$bvToast.toast(data.toastMessage, {
                title: 'Notification',
                variant:'success'
              })
            }
          }
        })
      }
      
      this.$emit('on-validate', this.model, isValid)
      return isValid
    },
    ...mapActions('job', [
      'submitCandidate'
    ]),
  },
  props:['data'],
  watch: { 
    data: function(newVal) { // watch it
      this.model = newVal
    }
  }
}
</script>

